module.exports = __webpack_public_path__ + "img/71.3f08330c.jpg";